import qs from 'query-string';
import React from 'react';
import { TempPasswordSent } from '../../components/HubspotSignUp/TempPasswordSent';
import routing from '../../services/routing';

export const TempPasswordSentRoute = () => (
    <TempPasswordSent username={qs.parse(routing.location.search).username as string} />
);
